export default "__VITE_ASSET__BoK8Bllp__"